
import { Book, Sparkles, Brain, BarChart3 } from "lucide-react";

const features = [
  {
    icon: Book,
    title: "Expert-Curated Content",
    description: "Articles and insights written by leading researchers and practitioners in the AI field."
  },
  {
    icon: Sparkles,
    title: "Premium Insights",
    description: "Exclusive analyses, technical deep dives, and industry forecasts for subscribers."
  },
  {
    icon: Brain,
    title: "AI Learning Paths",
    description: "Structured content journeys to help you master various AI domains and technologies."
  },
  {
    icon: BarChart3,
    title: "Trend Analysis",
    description: "Stay ahead with our data-driven insights on emerging AI trends and technologies."
  }
];

const FeaturesSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:text-center">
          <h2 className="text-base text-ai-indigo font-semibold tracking-wide uppercase">Features</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            Elevate Your AI Knowledge
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
            Explore the latest trends, research, and applications in artificial intelligence.
          </p>
        </div>

        <div className="mt-10">
          <div className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
            {features.map((feature, index) => (
              <div key={index} className="relative">
                <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-gradient-to-r from-ai-indigo to-ai-purple text-white">
                  <feature.icon className="h-6 w-6" />
                </div>
                <div className="ml-16">
                  <h3 className="text-lg leading-6 font-medium text-gray-900">{feature.title}</h3>
                  <p className="mt-2 text-base text-gray-500">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
